import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTrashBinStyle0 = gravityIconIndividualCss;

const GravityIconTrashBin = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7e27f5677eb2a14b0ac10e4d143b1caddd9f5801', color: this.color, size: this.size }, h("svg", { key: 'd48420f349389ca9aa8aa23d80c1a565506ce596', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'dd457593e6d0d96dfe5d966795eda97a532d33d1', d: "M14 3.5V4h4.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 5v-.5a.5.5 0 0 1 .5-.5H8v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm1.314 13.755.8-8.8A.5.5 0 0 1 16.615 8h.5a.5.5 0 0 1 .5.545l-.887 9.75a.5.5 0 0 1-.5.455H5.775a.5.5 0 0 1-.5-.455l-.887-9.75a.5.5 0 0 1 .5-.545h.5a.5.5 0 0 1 .497.46l.8 8.795h8.629Z", fill: "currentColor" }), h("path", { key: '576ca0f08b85818e5323d7e2af4045d18494d445', d: "m11.991 14.5.259-6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5l-.259 6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5Zm-3.741-6 .259 6a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5l-.259-6a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5Z", fill: "currentColor" }))));
    }
};
GravityIconTrashBin.style = GravityIconTrashBinStyle0;

export { GravityIconTrashBin as gravity_icon_trash_bin };

//# sourceMappingURL=gravity-icon-trash-bin.entry.js.map